// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YFzP","clinicsSelect":"styles_clinicsSelect__1cnwO"};